import type { Answers } from '../types/application';
import { propertyPhoto } from '../data/team';
import { formatCurrency, formatDate } from './format';

export interface PropertyContext {
  variant: 'contract' | 'shopping' | 'refinance';
  status: string;
  title: string;
  subtitle?: string;
  location?: string;
  detailLabel: string;
  detailValue: string;
  photo?: string;
}

export function getPropertyContext(a: Answers): PropertyContext {
  const location = [a.propertyCity, [a.propertyState, a.propertyZip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  if (a.goal === 'refinance') {
    return {
      variant: 'refinance',
      status: 'Refinance',
      title: a.propertyStreet || 'Your home',
      location,
      detailLabel: 'Estimated value',
      detailValue: formatCurrency(a.price),
      photo: a.propertyStreet ? propertyPhoto : undefined,
    };
  }
  if (a.propertyStage === 'contract' && a.propertyStreet) {
    return {
      variant: 'contract',
      status: 'Under contract',
      title: a.propertyStreet,
      location,
      detailLabel: 'Closing',
      detailValue: a.closingDate ? formatDate(a.closingDate) : 'To be scheduled',
      photo: propertyPhoto,
    };
  }
  return {
    variant: 'shopping',
    status: a.propertyStage === 'offers' ? 'Making offers' : 'Still shopping',
    title: 'Home purchase',
    subtitle: 'You’re getting pre-approved',
    detailLabel: 'Budget',
    detailValue: `Up to ${formatCurrency(a.price)}`,
  };
}
